

export class Admin_Dashboard_Daily_Present_Absent implements IAdmin_Dashboard_Daily_Present_Absent {
    totalEmployee!: number | undefined;
    totalPresent!: number | undefined;
    totalAbsent!: number | undefined;
    totalLeave!: number | undefined;
    presentPercentage!: number | undefined;
    absentPercentage!: number | undefined;
    leavePercentage!: number | undefined;
    totalWorkFromHome!: number | undefined;
    totalOffice!: number | undefined;
    totalSite!: number | undefined;
    totalOther!: number | undefined;

    constructor(data?: IAdmin_Dashboard_Daily_Present_Absent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEmployee = _data["totalEmployee"];
            this.totalPresent = _data["totalPresent"];
            this.totalAbsent = _data["totalAbsent"];
            this.totalLeave = _data["totalLeave"];
            this.presentPercentage = _data["presentPercentage"];
            this.absentPercentage = _data["absentPercentage"];
            this.leavePercentage = _data["leavePercentage"];
            this.totalWorkFromHome = _data["totalWorkFromHome"];
            this.totalOffice = _data["totalOffice"];
            this.totalSite = _data["totalSite"];
            this.totalOther = _data["totalOther"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Present_Absent {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Present_Absent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEmployee"] = this.totalEmployee;
        data["totalPresent"] = this.totalPresent;
        data["totalAbsent"] = this.totalAbsent;
        data["totalLeave"] = this.totalLeave;
        data["presentPercentage"] = this.presentPercentage;
        data["absentPercentage"] = this.absentPercentage;
        data["leavePercentage"] = this.leavePercentage;
        data["totalWorkFromHome"] = this.totalWorkFromHome;
        data["totalOffice"] = this.totalOffice;
        data["totalSite"] = this.totalSite;
        data["totalOther"] = this.totalOther;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Present_Absent {
    totalEmployee: number | undefined;
    totalPresent: number | undefined;
    totalAbsent: number | undefined;
    totalLeave: number | undefined;
    presentPercentage: number | undefined;
    absentPercentage: number | undefined;
    leavePercentage: number | undefined;
    totalWorkFromHome: number | undefined;
    totalOffice: number | undefined;
    totalSite: number | undefined;
    totalOther: number | undefined;
}

